export default {
      id: "viber-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "sprite-46b249.svg#viber-usage",
      toString: function () {
        return this.url;
      }
    }